import DownloadExcelButton from "./DownloadExcelButton";

const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  buildFilters   
}) => {
  const getPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push({ value: i, type: 'number' });
      }
    } else {
      pageNumbers.push({ value: 1, type: 'number' });

      if (currentPage > 4) {
        pageNumbers.push({ value: '...', type: 'ellipsis' });
      }

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pageNumbers.push({ value: i, type: 'number' });
      }

      if (currentPage < totalPages - 3) {
        pageNumbers.push({ value: '...', type: 'ellipsis' });
      }

      pageNumbers.push({ value: totalPages, type: 'number' });
    }

    return pageNumbers;
  };

  return (
    <div className="paginationsr">
      <div className="pagination-buttons">
        {/* Prev button */}
        <button
          className="paginationsr-btn"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &laquo;
        </button>

        {/* Smart Page Numbers */}
        {getPageNumbers().map(({ value, type }, index) =>
          type === 'ellipsis' ? (
            <span key={index} className="paginationsr-ellipsis">...</span>
          ) : (
            <button
              key={value}
              onClick={() => onPageChange(value)}
              className={`paginationsr-btn ${currentPage === value ? 'active' : ''}`}
            >
              {value}
            </button>
          )
        )}

        {/* Next button */}
        <button
          className="paginationsr-btn"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &raquo;
        </button>
      </div>

      {/* Items per page dropdown */}
      <select
        className="items-per-page"
        value={itemsPerPage}
        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
      >
        <option value={10}>10 per page</option>
        <option value={15}>15 per page</option>
        <option value={20}>20 per page</option>
      </select>
  <DownloadExcelButton buildFilters={buildFilters} />
    </div>
  );
};

export default Pagination;